var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-edit-1218875",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.994,
    height: 22,
    viewBox: "0 0 21.994 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13138_-_Outline",
    "data-name": "Path 13138 - Outline",
    d: "M147.509,98.627h-14.5A3.336,3.336,0,0,1,129.7,95.28v-14.5a3.306,3.306,0,0,1,3.317-3.288h8.754v1.8h-8.754a1.484,1.484,0,0,0-1.514,1.485v14.5a1.551,1.551,0,0,0,1.514,1.545h14.5a1.55,1.55,0,0,0,1.513-1.486V86.556h1.8V95.28A3.336,3.336,0,0,1,147.509,98.627Z",
    transform: "translate(-129.695 -76.627)",
    fill: "#24abe2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13139_-_Outline",
    "data-name": "Path 13139 - Outline",
    d: "M308.263,59.626a2.72,2.72,0,0,1,1.918.772,2.712,2.712,0,0,1,0,3.836l-8.1,8.1a.894.894,0,0,1-.42.237l-3.416.854a.883.883,0,0,1-.219.027.9.9,0,0,1-.874-1.12L298,68.92a.9.9,0,0,1,.237-.418l8.1-8.1A2.723,2.723,0,0,1,308.263,59.626ZM298.023,72.862Zm10.666-9.686.216-.216a.911.911,0,0,0-1.288-1.288l-.216.216Zm-1.274,1.276-1.288-1.288L299.692,69.6l-.429,1.717,1.717-.429Z",
    transform: "translate(-288.982 -59.626)",
    fill: "#24abe2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.d2b6d0a509f2248eb70e30043fa31199.svg";
export { ForwardRef as ReactComponent };